import React from "react";
import {Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./contexts/LanguageContext";

import Header from "./components/Header";
import AllReviews from "./pages/viewAllReviews/viewAllReviews.js";
import ViewAllGifts from "./pages/viewAllGifts/viewAllGifts.js";
import Privacy from "./pages/privacy/privacy.js";
import Terms from "./pages/terms/terms.js";
import Home from "./pages/Home/home.js";

export default function App() {
  return (
      <LanguageProvider>
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/see-all-reviews" element={<AllReviews />} />
            <Route path="/see-all-gifts" element={<ViewAllGifts />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
      </LanguageProvider>
  );
}